import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Button } from '@airia/ui';
import { getAddinPowerPointChatDeployment } from '../../services/agent';
import { classifyChatInitError, getChatInitErrorMessage, } from '../../services/chatInitError';
import { getRequiredConfig } from '../../lib/service-discovery';
import { useUserId } from '../../lib/useUserId';
import { PowerPointAdapter } from '../../lib/host-adapters/powerpoint-adapter';
import { AddinChat } from '../chat/AddinChat';
// Singleton adapter instance
const powerPointAdapter = new PowerPointAdapter();
export function PowerPointMain() {
    const { user, removeUser } = useAuth();
    const { userId } = useUserId();
    const [agentId, setAgentId] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [errorKind, setErrorKind] = useState();
    useEffect(() => {
        if (!user?.access_token)
            return;
        getAddinPowerPointChatDeployment(user.access_token)
            .then((deployment) => {
            setAgentId(deployment.pipelineId);
            setIsLoading(false);
        })
            .catch((err) => {
            console.error('[PowerPointMain] Failed to get deployment:', err);
            setErrorKind(classifyChatInitError(err));
            setIsLoading(false);
        });
    }, [user?.access_token]);
    if (isLoading) {
        return (_jsx("div", { className: "h-full flex flex-col items-center justify-center bg-background", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-border mx-auto mb-4" }), _jsx("p", { className: "text-sm text-foreground", children: "Loading..." })] }) }));
    }
    if (errorKind) {
        return (_jsx("div", { className: "h-full flex flex-col items-center justify-center bg-background", children: _jsxs("div", { className: "text-center p-4", children: [_jsx("p", { "data-testid": "chat-init-error", "data-error-kind": errorKind, className: "text-destructive mb-4", children: getChatInitErrorMessage(errorKind, 'PowerPoint') }), errorKind === 'auth' ? (
                    // Reloading can't fix a 401/403: the client still holds the token the server
                    // rejected. Dropping the stored user sends the taskpane back to its sign-in
                    // screen (App renders AuthNavigator once isAuthenticated is false).
                    _jsx(Button, { onClick: () => removeUser(), children: "Sign in again" })) : (_jsx(Button, { onClick: () => window.location.reload(), children: "Retry" }))] }) }));
    }
    if (!agentId || !user?.access_token) {
        return (_jsx("div", { className: "h-full flex flex-col items-center justify-center bg-background", children: _jsx("div", { className: "text-center p-4", children: _jsx("p", { className: "text-foreground", children: "No chat service available" }) }) }));
    }
    const config = getRequiredConfig();
    return (_jsx(AddinChat, { agentId: agentId, bearerToken: user.access_token, apiUrl: config.apiUrl, userId: userId ?? undefined, hostAdapter: powerPointAdapter, greeting: "Hello! I'm here to help you with your PowerPoint presentation. What would you like to know?" }));
}
